import React from 'react';
import SystemPreferences from '../customerDashboard/systemPreferences';
import EmailSettings from '../customerDashboard/emailSettings';
import AccessibilitySettings from '../customerDashboard/accessibilitySettings';
import PaymentMethods from '../customerDashboard/paymentMethods';
import WiFiPreferences from '../customerDashboard/wifiPreferences';
import DeviceSettingsCard from '../customerDashboard/deviceSettingsCard';
import './settingsPanel.css';

function SettingsPanel({ setting }) {
  return (
    <div className="settings-panel">
      <h2>{setting}</h2>

      {setting === 'System Preferences' ? (
        <SystemPreferences />
      ) : setting === 'Email Settings' ? (
        <EmailSettings />
      ) : setting === 'Personal Settings' ? (
        <AccessibilitySettings />
      ) : setting === 'Payment Methods' ? (
        <PaymentMethods />
      ) : setting === 'WiFi Preferences' ? (
        <WiFiPreferences />
      ) : setting === 'Device Settings' ? (
        <DeviceSettingsCard />
      ) : (
        <p>Configure your {setting.toLowerCase()} here.</p>
      )}
    </div>
  );
}

export default SettingsPanel;
